"use strict";

exports.__esModule = true;
exports.AlertDefinitionController = void 0;
var _react = require("react");
var _vimanaTypes = require("@vimana/vimana-types");
var AlertDefinitionController = exports.AlertDefinitionController = function AlertDefinitionController(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)([]),
    alerts = _useState[0],
    _setAlerts = _useState[1];
  return children({
    getAlerts: function getAlerts() {
      return alerts;
    },
    getAlert: function getAlert(i) {
      var _alerts$i;
      return (_alerts$i = alerts[i]) != null ? _alerts$i : {};
    },
    setAlerts: function setAlerts(alerts) {
      _setAlerts(alerts);
    },
    setAlert: function setAlert(alert, index) {
      if (alerts.length === 0) {
        _setAlerts([alert]);
        return;
      }
      var newAlerts = alerts.slice();
      newAlerts.splice(index, 1, alert);
      _setAlerts(newAlerts);
    },
    alerts: alerts
  });
};